import Notice from "@buildpy/ui/notice";
import { Button } from "@buildpy/ui/button";
import { Link } from "@/lib/nav";

// 없는 주소(legacy 는 Next 기본 404) — 무엇이 없는지와 돌아갈 길만 준다.
const NotFound = () => (
  <main className="flex min-h-[60vh] items-center justify-center p-4">
    <Notice
      actions={
        <Button asChild size="sm" variant="outline">
          <Link href="/">처음으로</Link>
        </Button>
      }
      body="주소가 잘못되었거나 없어진 화면입니다."
      title="페이지를 찾지 못했습니다"
    />
  </main>
);

export default NotFound;
